
import Vue from 'vue';

export const state = Vue.observable({
  mobileNavOpen: false,
  links: [
    {
      title: 'Home',
      path: '/',
    },
    {
      title: 'Who We Are',
      children: [
        {
          title: "Introduction",
          path: "/investment",
        },
        {
          title: "Our Technology",
          path: "/our-technology",
        },
        {
          title: "The Team",
          path: "/team",
        },
      ],
    },
    {
      title: 'Investment Solutions',
      children: [
        {
          title: "Taranis Market Sentiment",
          path: "/investment/tms",
        },
        {
          title: "Global Data Network",
          path: "/investment/gdn",
        },
      ],
    },
    {
      title: 'News',
      path: '/news',
    },
    {
      title: "Contact",
      path: "/contact",
    },
  ],
});

export const mutations = {
  toggleMobileNav () { state.mobileNavOpen = !state.mobileNavOpen },
  closeMobileNav () { state.mobileNavOpen = false },
};
